<div class="container-text d-flex align-items-center">
    <div>
        <h2 class="container-text__titolo text-brand-10 ls-h2-title" *ngIf="block.titolo" [innerHTML]="block.titolo">
        </h2>
        <subtitles class="container-text__sottotitolo text-neutral-40 ls-p-medium" *ngIf="block.sottotitolo"
            [innerHTML]="block.sottotitolo"></subtitles>
        <p class="container-text__testo_formattato text-neutral-40 ls-p" *ngIf="block.testo_formattato"
            [innerHTML]="helpersService.modifyLinks(block.testo_formattato, domainWebsite) | safeHtml"></p>
        <p class="container-text__testo" *ngIf="block.testo" [innerHTML]="block.testo"></p>
        <div class="container-text__cta d-flex line-discover-with-icon" *ngIf="block.link_cta">
            <a *ngIf="!isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(block.link_cta.url).path" [queryParams]="navigationService.splitUrlRouterLink(block.link_cta.url).queryParams">
                <p class="m-0 pb-1 ls-label-medium-semibold text-brand-40 text-uppercase" [innerHTML]="block.label_cta">
                </p>
            </a>
            <a *ngIf="isLinkEsternal" [href]="block.link_cta.url" target="_blank">
                <p class="m-0 pb-1 ls-label-medium-semibold text-brand-40 text-uppercase" [innerHTML]="block.label_cta">
                </p>
            </a>
            <i class="fa-solid fa-arrow-right text-brand-40" aria-hidden="true"></i>
        </div>
    </div>
</div>